module.exports = __webpack_public_path__ + "img/dosis-vignette.29f73f0f.jpg";